import React from 'react'
import './NameAndEdit.css'

const NameAndEditUI = ({name, onUpdateClick}) =>
  <div className='w_name_edit g_flex_h'>
    <span>{name}</span>
    <span className="icon icon-pencil" onClick={onUpdateClick}></span>
  </div>

export default NameAndEditUI
